/**
 * Health probe with retry — consumption-plan cold starts run 15–30s, so a
 * single fetch misreports a healthy API as broken. fetch/sleep are injected
 * for testability.
 */
export interface ProbeResult {
  httpStatus: number;
  body: unknown;
}

export type FetchLike = (url: string) => Promise<{ ok: boolean; status: number; json(): Promise<unknown> }>;

export async function probeWithRetry(
  url: string,
  fetchFn: FetchLike,
  sleep: (ms: number) => Promise<void>,
  attempts = 6,
  delayMs = 5000,
  onWaiting?: (attempt: number) => void,
): Promise<ProbeResult> {
  let last: ProbeResult = { httpStatus: 0, body: null };
  for (let i = 1; i <= attempts; i++) {
    try {
      const res = await fetchFn(url);
      if (res.ok) return { httpStatus: res.status, body: await res.json() };
      last = { httpStatus: res.status, body: null };
    } catch {
      last = { httpStatus: 0, body: null };
    }
    if (i < attempts) {
      onWaiting?.(i);
      await sleep(delayMs);
    }
  }
  return last;
}
